import React from "react";

function SolutionHeading() {
  return (
    <div className="border border-amber mt-6 rounded-md shadow-2xl ring-1 ring-gray-900/10 px-10 py-10  mx-auto max-w-5xl text-center">
      <h2 className="text-4xl font-bold tracking-tight text-amber sm:text-6xl">
        How can I send a mobile top-up?
      </h2>
      <p className="mt-6 text-lg leading-8 text-navy">
        Simply Send "Hi" on{" "}
        <a
          href="https://wa.me/27769965252?text=Hi"
          target="_blank"
          rel="noopener noreferrer"
          class="text-amber underline"
        >
          WhatsApp
        </a>{" "}
        to get started, and follow our easy steps to place your order. There is
        no registration required. We use WhatsApp technology to make your life
        easier.
      </p>
    </div>
  );
}

export default SolutionHeading;
